/* Dependencies */
import * as yup from 'yup';

// Models
import {
  AirMonitor,
  UpdateAirMonitorReducer,
} from '../../../../store/slices/Forms/Forms.model';

export interface UpdateAirMonitorFormProps {
  /**
   * Site Id
   */
  siteId: string;
  /**
   * Current floor id.
   */
  floorId: string;
  /**
   * Current space id.
   */
  spaceId: string;
  /**
   * The Air monitor being edited.
   */
  data: AirMonitor;
  /**
   * Callback function to handle form submission.
   */
  onSubmit: (data: UpdateAirMonitorReducer) => void;
}
export interface InitialValues {
  /**
   * Name of the monitor
   */
  name: string;
  /**
   * Location of the air monitor.
   */
  location: string;
  /**
   * Device id of the air monitor.
   */
  deviceId: string;
  /**
   * Device Type
   */
  deviceType: string;
  /**
   * Serial number of the air monitor.
   */
  serialNumber: string;
  /**
   * Photo of the air monitor.
   */
  photo: File | null;
  /**
   * Comment of the air monitor.
   */
  comment: string;
}

export const UpdateAirMonitorFormSchema = yup.object({
  name: yup.string().required('Field is required'),
  location: yup.string().required('Field is required'),
  serialNumber: yup.string().required('Field is required'),
  deviceId: yup.string().required('Field is required'),
  deviceType: yup.string().required('Field is required'),
  photo: yup.mixed().optional(),
  comment: yup.string().optional(),
});
